import moment from 'moment'

// days is what gets enforced, weeks is what the user reads. They don't match
// exactly because the day limits predate the message, and shortening them would
// take away range that people already use.
export const getReportRangeLimit = (paramCount = 0, deviceCount = 0) => {
  if (paramCount > 8 && deviceCount > 35) return { days: 30, weeks: 4 }
  if (paramCount > 8) return { days: 60, weeks: 8 }
  if (paramCount > 4) return { days: 74, weeks: 10 }
  return { days: 120, weeks: 16 }
}

export const getReportDaysRange = (startDate, endDate) =>
  Math.max(0, moment(endDate).diff(moment(startDate), 'days'))

export const isReportRangeTooLong = (startDate, endDate, limit) =>
  getReportDaysRange(startDate, endDate) > limit.days

// Shortest first, so clamping can walk backwards to the longest option that fits.
export const AUTO_RANGES = [
  { key: '1w', days: 7 },
  { key: '2w', days: 14 },
  { key: '1M', days: 30 },
  { key: '2M', days: 60 }
]

// The 2M option has always been hidden above 35 devices, independently of the
// day limit. Keeping that rule so the dropdown does not grow for people who
// never had the option.
export const getAutoRangeOptions = (limit, deviceCount = 0) =>
  AUTO_RANGES.filter(range => range.days <= limit.days && (range.key !== '2M' || deviceCount < 35))

// Falls back to the longest range that still fits rather than to the shortest:
// the user asked for as much data as possible, so take away as little as we can.
export const clampAutoRange = (rangeKey, options) => {
  if (options.some(range => range.key === rangeKey)) return rangeKey
  return options.length > 0 ? options[options.length - 1].key : AUTO_RANGES[0].key
}

export const getAutoRangeDays = rangeKey =>
  (AUTO_RANGES.find(range => range.key === rangeKey) || AUTO_RANGES[0]).days
